export const LOAD_TICKETS = "LOAD_TICKETS";
export const ADD_TICKETS = "ADD_TICKETS";
